import { redirectLogOut, redirectMobileLogOut } from '@/utils/common/redirect-util';

import { useAuthenticationStore } from '@/stores/authentication';
import { useAuthorityStore } from '@/stores/authority';
import { useBaseInfoStore } from '@/stores/base-info';
import { showFailToast } from 'vant';
import dayjs from 'dayjs';
import { isLocal, isProd } from '@/utils/common/env-util';
import {
  getClientTimeByDiff,
  getServerTimeByDiff,
} from '@/utils/common/server-client-time';
import { randomNumberOrLetter } from '@/utils/common/string-util';
import { closeLoading } from '@/utils/feedback/loading';
import CryptoJS from 'crypto-js';

import { desEncrypt } from '@/utils/common/encrypt-util';
import { ElLoading } from 'element-plus';
import { renewToken } from '@/apis/modules/auth/auth';
import { HttpStatusCode } from './http-status-code';

const useAuthority = useAuthorityStore();
const useBaseInfo = useBaseInfoStore();
const useAuthentication = useAuthenticationStore();

/**
 * 弹出消息提示框
 *
 * @param message 提示消息内容
 * @param type 消息类型，可选值为 'success'、'warning'、'info'、'error'
 */
const curElMessage = (message, type) => {
  ElMessage({
    message,
    type,
    duration: 0,
    showClose: true,
  });
};

/**
 * 使用Element处理Http错误（mobile）
 * @param {number} statusCode 错误码
 * @param {string} statusText 错误描述
 * @param {object} responseData 响应内容
 */
const handleMobileHttpErrorWithEl = async (
  statusCode,
  responseData,
  response,
  request,
) => {
  // 隐藏加载中
  closeLoading();
  switch (statusCode) {
    case HttpStatusCode.Unauthorized:
      if (useAuthentication.alertToLogin) {
        return true;
      }
      // 根据返回的票决类型判断是续签，就需要调接口刷新，否则直接提示

      if (responseData.code === 'A0307') {
        // 临时过期刷新凭证
        if (!useAuthentication.refreshing) {
          useAuthentication.setRefreshing(true);

          // const renewToken = (data) =>
          //   request.post(`/auth/renew-token`, data, {
          //     tokenType: 'none',
          //     Refreshing: true,
          //   });

          const res = await renewToken({
            ticket: responseData.data.ticket,
          }).catch((error) => {
            console.log(error);
            console.log('续签失败');
          });

          res.data.clientTimestamp = getClientTimeByDiff(
            new Date(res.data.timestamp),
          ).getTime();
          useAuthentication.setRefreshing(false);
          useAuthority.setAuthToken(res.data);
          // 续签后再次发起请求
          return request(response.config);
        }
      } else if (responseData.code === 'A0211') {
        // 账号已在其他设备登录，被踢下线
        if (useAuthentication.alertToLogin) {
          return true;
        }
        if (request.interceptors?.request?.customConfig?.unAlertToLogin) {
          return {};
        }
        localStorage.setItem('kickout_msg', '您的账号已在其他设备登录，您已被迫下线，请重新登录');
        useAuthentication.setAlertToLogin(true);
        showFailToast({
          message: '您的账号已在其他设备登录，您已被迫下线',
          duration: 5000,
        });
        setTimeout(() => {
          useAuthentication.setAlertToLogin(false);
          localStorage.removeItem('kickout_msg');
          redirectMobileLogOut();
        }, 2000);
      } else {
        // 如果配置了不提示登录，则跳过，返回{}，抛由外部自定义处理
        if (request.interceptors?.request?.customConfig?.unAlertToLogin) {
          return {};
        }
        return true;
        // useAuthentication.setAlertToLogin(true);
        // useAuthentication.setAlertToLogin(false);
        // redirectLogOut();
        // ElMessageBox.alert('登录信息已过期，请重新登录！', {
        //   type: 'warning',
        //   showClose: false,
        //   confirmButtonText: '去登录',
        // }).then(() => {
        //   useAuthentication.setAlertToLogin(false);
        //   redirectLogOut();
        // });
      }
      return true;
    default:
      // 根据返回的msg判断是否需要提示
      if (responseData.msg && responseData.code !== '00000') {
        showFailToast({
          message: responseData.msg,
          duration: 5000,
        });
        // curElMessage(responseData.msg, 'error');
        // 统一处理自定义load加载中关闭
        // ElLoading.service()?.close();
      }
      return false;
  }
};

/**
 * 使用Element处理Http错误
 * @param {number} statusCode 错误码
 * @param {string} statusText 错误描述
 * @param {object} responseData 响应内容
 */
const handleHttpErrorWithEl = async (
  statusCode,
  responseData,
  response,
  request,
) => {
  // 隐藏加载中
  closeLoading();
  switch (statusCode) {
    case HttpStatusCode.Unauthorized:
      if (useAuthentication.alertToLogin) {
        return true;
      }
      // 根据返回的票决类型判断是续签，就需要调接口刷新，否则直接提示

      if (responseData.code === 'A0307') {
        // 临时过期刷新凭证
        if (!useAuthentication.refreshing) {
          useAuthentication.setRefreshing(true);

          // const renewToken = (data) =>
          //   request.post(`/auth/renew-token`, data, {
          //     tokenType: 'none',
          //     Refreshing: true,
          //   });

          const res = await renewToken({
            ticket: responseData.data.ticket,
          }).catch((error) => {
            console.log(error);
            console.log('续签失败');
          });

          res.data.clientTimestamp = getClientTimeByDiff(
            new Date(res.data.timestamp),
          ).getTime();
          useAuthentication.setRefreshing(false);
          useAuthority.setAuthToken(res.data);
          // 续签后再次发起请求
          return request(response.config);
        }
      } else if (responseData.code === 'A0211') {
        // 账号已在其他设备登录，被踢下线
        if (useAuthentication.alertToLogin) {
          return true;
        }
        // 如果配置了不提示登录，则跳过，返回{}，抛由外部自定义处理
        if (request.interceptors?.request?.customConfig?.unAlertToLogin) {
          return {};
        }
        localStorage.setItem('kickout_msg', '您的账号已在其他设备登录，您已被迫下线，请重新登录');
        useAuthentication.setAlertToLogin(true);
        ElMessageBox.alert('您的账号已在其他设备登录，您已被迫下线，请重新登录', {
          type: 'warning',
          showClose: false,
          confirmButtonText: '去登录',
        }).then(() => {
          useAuthentication.setAlertToLogin(false);
          localStorage.removeItem('kickout_msg');
          redirectLogOut();
        });
      } else {
        // 如果配置了不提示登录，则跳过，返回{}，抛由外部自定义处理
        if (request.interceptors?.request?.customConfig?.unAlertToLogin) {
          return {};
        }
        useAuthentication.setAlertToLogin(true);
        ElMessageBox.alert('登录信息已过期，请重新登录！', {
          type: 'warning',
          showClose: false,
          confirmButtonText: '去登录',
        }).then(() => {
          useAuthentication.setAlertToLogin(false);

          redirectLogOut();
        });
      }
      return true;
    default:
      // 根据返回的msg判断是否需要提示
      if (responseData.msg && responseData.code !== '00000') {
        curElMessage(responseData.msg, 'error');
        // 统一处理自定义load加载中关闭
        ElLoading.service()?.close();
      }
      return false;
  }
};

/**
 * 处理Http错误
 * @param {number} statusCode 错误码
 * @param {string} statusText 错误描述
 * @param {object} responseData 响应内容
 */
const handleHttpError = (statusCode, responseData, response, request) => {
  switch (useBaseInfo.vueLayout) {
    case 'mobile':
      return handleMobileHttpErrorWithEl(
        statusCode,
        responseData,
        response,
        request,
      );
    case 'admin':
    case 'front':
    case 'empty':
      return handleHttpErrorWithEl(statusCode, responseData, response, request);

    default:
      return false;
  }
};

/**
 * 处理响应头
 * @param {Object} headers 响应头
 */
const handleResponseHeaders = (headers) => {
  const date = headers.Date ? headers.Date : headers.date;
  const serverTime = dayjs(date);
  if (Object.prototype.toString.call(serverTime.$d) === '[object Date]') {
    useBaseInfo.setServerTime(serverTime.$d);
  } else {
    console.warn('cannot read server date in response headers');
  }
};

/**
 * 将传入的值转化为字符串
 *
 * @param value 要转化的值
 * @returns 转化后的字符串
 */
function stringify(value) {
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return value.toString();
}

/**
 * 判断值是否需要签名
 * null、undefined、空字符串、'null'、'undefined'、File类型不需要签名
 * @param {any} value 值
 * @returns 是/否
 */
function isValueNeedSign(value) {
  if (
    value === null ||
    value === undefined ||
    value === '' ||
    value === 'null' ||
    value === 'undefined'
  ) {
    return false;
  }

  if (
    Object.prototype.toString.call(value) === '[object File]' ||
    Object.prototype.toString.call(value) === '[object Blob]'
  ) {
    return false;
  }

  return true;
}
/**
 * 移除字符串中的换行符和空格
 *
 * @param str 要处理的字符串
 * @returns 返回处理后的字符串，其中所有的换行符（\r\n、\n）和空格被移除
 */
function removeNewLinesAndSpaces(str) {
  // 正则表达式匹配 \r\n、\n 和空格

  const regex = /[\r\n\s\u00A0]+|\\n|\\r/g;
  return str.replace(regex, '');

  // const regex = /[\r\n\s]+/g;
  // // 使用空字符串替换匹配到的字符
  // return str.replace(regex, '').replace(/\\n/g, '').replace(/\\r/g, '');
}

/**
 * 获取签名用的参数
 *
 * @param paramObj 参数对象
 * @returns 签名用的参数
 */
function getParamForSign(isNotStringifyParams, paramObj) {
  const sortKeys = Reflect.ownKeys(paramObj).sort();
  const signParamObj = {};
  sortKeys.forEach((key) => {
    const value = paramObj[key];
    // 过滤掉不需要签名的参数，null、undefined、空字符串、'null'、'undefined'，File类型不需要签名
    if (isValueNeedSign(value)) {
      Reflect.set(
        signParamObj,
        key,
        isNotStringifyParams ? value : stringify(value),
      );
    }
  });
  const result = removeNewLinesAndSpaces(JSON.stringify(signParamObj));
  console.log('param result：', result);
  return result;
}

/**
 * 签名
 * @param {Object} params 请求参数
 * @param {Number} timestamp 时间戳
 * @param {String} nonce 随机字符串
 */
function sign(isNotStringifyParams, params, timestamp, nonce) {
  const signParam = getParamForSign(isNotStringifyParams, params);
  // console.log('params :>> ', params);
  // console.log('signParam :>> ', signParam);

  const token = 'sr.token@2023';
  const str = signParam + timestamp + nonce + token;
  return CryptoJS.SHA256(str).toString();
}

/**
 * 处理请求头
 * @param {Object} headers 请求头
 * @param {Object} config 请求配置
 */
const handleRequestHeaders = async (headers, config) => {
  // 设置时间戳和随机字符串
  headers.srt = getServerTimeByDiff()?.getTime();
  headers.srn = randomNumberOrLetter(16);
  headers.srs = sign(
    !!headers['Content-Type']?.includes('application/json'),
    config.originData || {},
    headers.srt,
    headers.srn,
  );

  const curMenu = useAuthority.pageFunctionObj[useAuthority.menuUrl]?.menuCode;
  if (curMenu) {
    headers.m = desEncrypt(curMenu);
  }

  // 是否验证登录
  if (config.tokenType !== 'none') {
    headers[useAuthority.authToken.name] = useAuthority.authToken.value;
  }
  if (config.sourceType) {
    headers.sourceType = useAuthority.terminal;
  }
};

/**
 * 解密数据
 *
 * @param item 待解密的对象
 */
const decryptData = (praItem) => {
  const item = praItem;
  const secretKey = import.meta.env.VITE_AES_KEY;
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(secretKey);

  // 首先看对象里是否有encryptedFields
  const keyArray = Object.keys(item);
  if (keyArray.filter((x) => x === 'encryptedFields').length > 0) {
    const encryptedFieldArray = item.encryptedFields;
    // 遍历encryptedFieldArray
    encryptedFieldArray.forEach((field) => {
      // try catch
      try {
        const base64 = CryptoJS.enc.Base64.parse(item[field]);
        const src = CryptoJS.enc.Base64.stringify(base64);

        const decrypt = CryptoJS.AES.decrypt(src, key, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding,
        });

        const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        item[field] = decryptedStr.toString().trim();
      } catch (e) {
        console.error(e);
      }
    });
  }
};
/**
 * 处理请求数据
 *
 * @param data 请求数据，可以为数组或对象
 * @returns 无返回值
 */
const handleRequestData = (data) => {
  if (!data) {
    return null;
  }
  if (Array.isArray(data)) {
    data.forEach((item) => {
      if (Array.isArray(item)) {
        handleRequestData(item); // 递归处理数组中的数组
      } else if (typeof item === 'object' && item !== null) {
        const keyArray = Object.keys(item);
        keyArray
          .filter((x) => x !== 'encryptedFields')
          .forEach((key) => {
            handleRequestData(item[key]); // 递归调用
          });
        // 处理对象中的值
        decryptData(item);
      }
    });
  } else if (typeof data === 'object' && data !== null) {
    Object.values(data).forEach((value) => {
      if (Array.isArray(value)) {
        handleRequestData(value); // 递归处理对象中的数组
      } else if (typeof value === 'object' && value !== null) {
        handleRequestData(Object.values(value)); // 递归处理对象中的对象
      }
    });
  }

  return data;
};

// region 打印日志

// 是否允许打印api日志
const enableLogApi = !isProd && isLocal;

/**
 * 改变console方法
 * @param {Function} factory 工厂函数
 * @param {Boolean} enable 是否开启日志
 * @returns {Function}
 */
const changeConsole = (factory, enable) => {
  return (...args) => enable && factory(...args);
};

// 打印api日志方法
const logApiBegin = changeConsole(console.groupCollapsed, enableLogApi);
const logApi = changeConsole(console.log, enableLogApi);
const logApiEnd = changeConsole(console.groupEnd, enableLogApi);

/**
 * 打印请求日志
 * @param {Object} config axios请求配置
 */
const logRequest = (config) => {
  if (import.meta.env.VITE_API_ENABLE_LOG !== 'false') {
    const logUrl = `请求地址: ${config.url}`;
    logApiBegin(`%c${logUrl} (failed)`, 'color: #fe3333');
    logApi('请求方式:', config.method);
    logApi(
      '请求头部:',
      config.headers
        ? { ...config.headers.common, ...config.headers[config.method] }
        : '',
    );
    logApi('请求参数:', config.originData ?? '');
    logApiEnd();
  }
};

/**
 * 打印请求和响应日志
 * @param {Object} response axios响应
 */
const logRequestAndResponse = (response) => {
  // 如果响应中不包含配置，则不打印
  const { config } = response;
  if (!config) {
    return;
  }

  if (import.meta.env.VITE_API_ENABLE_LOG !== 'false') {
    const logUrl = `请求地址: ${config.url}`;

    if (
      import.meta.env.MODE === 'resident' ||
      import.meta.env.MODE === 'testing'
    ) {
      if (response.status === 200) {
        console.groupCollapsed(logUrl);
      } else {
        console.groupCollapsed(
          `%c${logUrl} (${response.status})`,
          'color: #fe3333',
        );
      }
      console.log('请求方式:', config.method);
      console.log('请求头部:', config.headers);
      console.log('请求参数:', config.originData ?? '');
      console.log('响应头部:', response.headers);
      console.log('后端协调:', {
        请求地址: config.url,
        响应状态: response.status,
        请求头部: {
          sa: config.headers.sa,
        },
        请求参数: config.originData || '',
        响应结果:
          response.status === 200
            ? {
                ...response.data,
                data: [],
              }
            : response.data,
      });
      console.log('响应结果:', response.data);
      console.log('响应耗时:', `${new Date() - config.custom.requestTime}ms`);
      console.groupEnd();
    } else {
      if (response.status === 200) {
        logApiBegin(logUrl);
      } else {
        logApiBegin(`%c${logUrl} (${response.status})`, 'color: #fe3333');
      }
      logApi('请求方式:', config.method);
      logApi('请求头部:', config.headers);
      logApi('请求参数:', config.originData ?? '');
      logApi('响应头部:', response.headers);
      logApi('后端协调:', {
        请求地址: config.url,
        响应状态: response.status,
        请求头部: {
          sa: config.headers.sa,
        },
        请求参数: config.originData || '',
        响应结果:
          response.status === 200
            ? {
                ...response.data,
                data: [],
              }
            : response.data,
      });
      logApi('响应结果:', response.data);
      logApi('响应耗时:', `${new Date() - config.custom.requestTime}ms`);
      logApiEnd();
    }
  }
};

// endregion

/**
 * 对象转表单
 * @param {Object} data 对象
 * @returns {FormData} 表单
 */
const object2FormData = (data) => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return formData;
};

export {
  handleHttpError,
  handleRequestData,
  handleRequestHeaders,
  handleResponseHeaders,
  logRequest,
  logRequestAndResponse,
  object2FormData,
};
